var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	759: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_primitives_signals_angular_core_primitiv-a0f1dc"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__linked_signal-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__resource-chunk_mjs"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",
	},
	52950: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022__browser-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022_platform-browser_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",
	},
	92668: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-node_modules_ngrx_store_fesm2022_ngrx-store_mjs")]).then(() => (() => (__webpack_require__(/*! @ngrx/store */ 81383))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/store",
	},
	59089: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022__browser-chunk_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_animations_browser_angular_animations_browser"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser/animations */ 43835))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser/animations",
	},
	32994: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_forms_angular_forms"), __webpack_require__.e("default-node_modules_ngx-mask_fesm2022_ngx-mask_mjs")]).then(() => (() => (__webpack_require__(/*! ngx-mask */ 86769))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ngx-mask",
	},
	9649: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_router_fesm2022_router_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",
	},
	30171: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_ngrx_effects_fesm2022_ngrx-effects_mjs")]).then(() => (() => (__webpack_require__(/*! @ngrx/effects */ 70347))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/effects",
	},
	68324: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_config_ng-zorro-antd_core_config"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_icon_ng-zorro-antd_icon"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_transition-patch_ng-zorro-antd_cor-88efb7"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_forms_angular_forms"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_button_ng-zorro-antd_button"), __webpack_require__.e("default-webpack_sharing_consume_default_lucide-angular_lucide-angular"), __webpack_require__.e("default-webpack_sharing_consume_default_aws-amplify_auth_aws-amplify_auth"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_drag-drop_angular_cdk_drag-drop"), __webpack_require__.e("default-libs_shared-ui_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @org/shared-ui */ 22592))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@org/shared-ui",
	},
	53962: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_aws-amplify_core_dist_esm_Platform_index_mjs-node_modules_aws-amplify_co-d5eb63"), __webpack_require__.e("default-node_modules_aws-amplify_core_dist_esm_clients_endpoints_getDnsSuffix_mjs-node_module-1e6207"), __webpack_require__.e("default-node_modules_aws-amplify_auth_dist_esm_providers_cognito_tokenProvider_tokenProvider_mjs"), __webpack_require__.e("default-node_modules_aws-amplify_auth_dist_esm_providers_cognito_credentialsProvider_index_mjs"), __webpack_require__.e("node_modules_aws-amplify_dist_esm_index_mjs")]).then(() => (() => (__webpack_require__(/*! aws-amplify */ 36058))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "aws-amplify",
	},
	56202: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_aws-amplify_core_dist_esm_Platform_index_mjs-node_modules_aws-amplify_co-d5eb63"), __webpack_require__.e("default-node_modules_aws-amplify_core_dist_esm_clients_endpoints_getDnsSuffix_mjs-node_module-1e6207"), __webpack_require__.e("default-node_modules_aws-amplify_core_dist_esm_clients_middleware_signing_middleware_mjs-node-f0ee09"), __webpack_require__.e("node_modules_aws-amplify_dist_esm_utils_index_mjs")]).then(() => (() => (__webpack_require__(/*! aws-amplify/utils */ 72464))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "aws-amplify/utils",
	},
	67674: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_aws-amplify_core_dist_esm_Platform_index_mjs-node_modules_aws-amplify_co-d5eb63"), __webpack_require__.e("default-node_modules_aws-amplify_core_dist_esm_clients_endpoints_getDnsSuffix_mjs-node_module-1e6207"), __webpack_require__.e("default-node_modules_aws-amplify_auth_dist_esm_providers_cognito_tokenProvider_tokenProvider_mjs"), __webpack_require__.e("default-node_modules_aws-amplify_auth_dist_esm_providers_cognito_apis_confirmResetPassword_mj-2bc2b5"), __webpack_require__.e("default-node_modules_aws-amplify_auth_dist_esm_providers_cognito_credentialsProvider_index_mjs"), __webpack_require__.e("node_modules_aws-amplify_dist_esm_auth_cognito_index_mjs")]).then(() => (() => (__webpack_require__(/*! aws-amplify/auth/cognito */ 69053))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "aws-amplify/auth/cognito",
	},
	86447: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-node_modules_ngrx_store-devtools_fesm2022_ngrx-store-devtools_mjs")]).then(() => (() => (__webpack_require__(/*! @ngrx/store-devtools */ 11925))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/store-devtools",
	},
	61528: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.8.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",
	},
	48196: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.8.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",
	},
	40845: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",
	},
	89193: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_angular_core_fesm2022__linked_signal-chunk_mjs"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_core_fesm2022_primitives-signals_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 36699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",
	},
	52409: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 8513))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",
	},
	45211: {
		fallback: () => (__webpack_require__.e("default-node_modules_angular_animations_fesm2022_browser_mjs").then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 10655))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations/browser",
	},
	59715: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_http_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",
	},
	19315: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_primitives_signals_angular_core_primitiv-a0f1dc"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__linked_signal-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__resource-chunk_mjs"), __webpack_require__.e("node_modules_angular_core_fesm2022_rxjs-interop_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",
	},
	25048: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_util_ng-zorro-antd_core_util"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_logger_ng-zorro-antd_core_logger"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_color_ng-zorro-antd_core_color"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_primitives_signals_angular_core_primitiv-a0f1dc"), __webpack_require__.e("default-node_modules_ctrl_tinycolor_dist_module_format-input_js"), __webpack_require__.e("default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-core-config_mjs")]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/config */ 44300))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/config",
	},
	78216: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_util_ng-zorro-antd_core_util"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_config_ng-zorro-antd_core_config"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_logger_ng-zorro-antd_core_logger"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_platform_angular_cdk_platform"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-icon_mjs")]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/icon */ 42715))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/icon",
	},
	92156: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/transition-patch */ 76902))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/transition-patch",
	},
	33611: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_forms_fesm2022_forms_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",
	},
	13824: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_util_ng-zorro-antd_core_util"), __webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_config_ng-zorro-antd_core_config"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_space_ng-zorro-antd_space"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_wave_ng-zorro-antd_core_wave"), __webpack_require__.e("default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-button_mjs")]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/button */ 56104))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/button",
	},
	55159: {
		fallback: () => (__webpack_require__.e("default-node_modules_lucide-angular_fesm2020_lucide-angular_mjs").then(() => (() => (__webpack_require__(/*! lucide-angular */ 1903))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^0.562.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "lucide-angular",
	},
	9266: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_aws-amplify_core_dist_esm_Platform_index_mjs-node_modules_aws-amplify_co-d5eb63"), __webpack_require__.e("default-node_modules_aws-amplify_core_dist_esm_clients_endpoints_getDnsSuffix_mjs-node_module-1e6207"), __webpack_require__.e("default-node_modules_aws-amplify_auth_dist_esm_providers_cognito_tokenProvider_tokenProvider_mjs"), __webpack_require__.e("default-node_modules_aws-amplify_auth_dist_esm_providers_cognito_apis_confirmResetPassword_mj-2bc2b5"), __webpack_require__.e("node_modules_aws-amplify_dist_esm_auth_index_mjs")]).then(() => (() => (__webpack_require__(/*! aws-amplify/auth */ 50181))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "aws-amplify/auth",
	},
	72548: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_scrolling_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_drag-drop_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/cdk/drag-drop */ 50854))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/drag-drop",
	},
	79732: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_util_ng-zorro-antd_core_util"), __webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_outlet_ng-zorro-antd_core_outlet"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_platform_angular_cdk_platform"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_polyfill_ng-zorro-antd_core_polyfill"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_keycodes_angular_cdk_keycodes"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_overlay_angular_cdk_overlay"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_space_ng-zorro-antd_space"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_overlay_ng-zorro-antd_core_overlay"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_a11y_angular_cdk_a11y"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_animation_ng-zorro-antd_core_animation"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_form_ng-zorro-antd_core_form"), __webpack_require__.e("default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-select_mjs")]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/select */ 14328))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/select",
	},
	96288: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_util_ng-zorro-antd_core_util"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_logger_ng-zorro-antd_core_logger"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_platform_angular_cdk_platform"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_keycodes_angular_cdk_keycodes"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_i18n_ng-zorro-antd_i18n"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_animation_ng-zorro-antd_core_animation"), __webpack_require__.e("default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-upload_mjs")]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/upload */ 66691))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/upload",
	},
	46700: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_util_ng-zorro-antd_core_util"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_outlet_ng-zorro-antd_core_outlet"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_logger_ng-zorro-antd_core_logger"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_polyfill_ng-zorro-antd_core_polyfill"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_keycodes_angular_cdk_keycodes"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_overlay_angular_cdk_overlay"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_i18n_ng-zorro-antd_i18n"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_wave_ng-zorro-antd_core_wave"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_overlay_ng-zorro-antd_core_overlay"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_a11y_angular_cdk_a11y"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_portal_angular_cdk_portal"), __webpack_require__.e("default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-modal_mjs")]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/modal */ 51663))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/modal",
	},
	57474: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_aws-amplify_core_dist_esm_Platform_index_mjs-node_modules_aws-amplify_co-d5eb63"), __webpack_require__.e("default-node_modules_aws-amplify_core_dist_esm_clients_middleware_signing_middleware_mjs-node-f0ee09"), __webpack_require__.e("default-node_modules_aws-amplify_dist_esm_api_index_mjs")]).then(() => (() => (__webpack_require__(/*! aws-amplify/api */ 95247))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "aws-amplify/api",
	},
	96210: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_util_ng-zorro-antd_core_util"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_outlet_ng-zorro-antd_core_outlet"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_platform_angular_cdk_platform"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_keycodes_angular_cdk_keycodes"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_space_ng-zorro-antd_space"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_wave_ng-zorro-antd_core_wave"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_a11y_angular_cdk_a11y"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_form_ng-zorro-antd_core_form"), __webpack_require__.e("default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-input_mjs")]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/input */ 87084))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/input",
	},
	56352: {
		fallback: () => (__webpack_require__.e("default-node_modules_ngrx_signals_fesm2022_ngrx-signals_mjs").then(() => (() => (__webpack_require__(/*! @ngrx/signals */ 61803))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/signals",
	},
	23316: {
		fallback: () => (__webpack_require__.e("node_modules_ngrx-store-localstorage_fesm2022_ngrx-store-localstorage_mjs").then(() => (() => (__webpack_require__(/*! ngrx-store-localstorage */ 95871))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ngrx-store-localstorage",
	},
	13192: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_logger_ng-zorro-antd_core_logger"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_coercion_angular_cdk_coercion"), __webpack_require__.e("node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-core-util_mjs")]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/util */ 66906))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/util",
	},
	3132: {
		fallback: () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_bidi_mjs-_04d91").then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 63680))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/bidi",
	},
	43294: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_config_ng-zorro-antd_core_config"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_outlet_ng-zorro-antd_core_outlet"), __webpack_require__.e("default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-space_mjs")]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/space */ 13378))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/space",
	},
	67870: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_platform_angular_cdk_platform"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/wave */ 69741))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/wave",
	},
	37394: {
		fallback: () => (__webpack_require__.e("node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-core-polyfill_mjs").then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/polyfill */ 58191))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/polyfill",
	},
	21048: {
		fallback: () => (Promise.all([__webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_cdk_fesm2022__array-chunk_mjs-node_modules_angular_cdk_fesm2022__css-pix-e68fae1")]).then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 2814))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/coercion",
	},
	74236: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_environments_ng-zorro-antd_core_en-53451e"), __webpack_require__.e("node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-core-logger_mjs")]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/logger */ 24658))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/logger",
	},
	32174: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_ctrl_tinycolor_dist_module_format-input_js"), __webpack_require__.e("node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-core-color_mjs")]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/color */ 7691))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/color",
	},
	80388: {
		fallback: () => (__webpack_require__.e("node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-core-environments_mjs").then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/environments */ 23444))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/environments",
	},
	53048: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_scrolling_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_portal_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_overlay_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 81570))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/overlay",
	},
	52538: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_cdk_fesm2022__passive-listeners-chunk_mjs-node_modules_angular_cdk_fesm2-bf011d1")]).then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 17699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/platform",
	},
	73916: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_cdk_fesm2022__breakpoints-observer-chunk_mjs-_5dc71")]).then(() => (() => (__webpack_require__(/*! @angular/cdk/layout */ 87912))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/layout",
	},
	22294: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_util_ng-zorro-antd_core_util"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/outlet */ 3317))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/outlet",
	},
	83672: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_logger_ng-zorro-antd_core_logger"), __webpack_require__.e("default-node_modules_date-fns_esm__lib_getTimezoneOffsetInMilliseconds_index_js-node_modules_-160fe1"), __webpack_require__.e("default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-i18n_mjs")]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/i18n */ 29840))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/i18n",
	},
	73856: {
		fallback: () => (__webpack_require__.e("default-node_modules_angular_cdk_fesm2022_portal_mjs").then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/portal",
	},
	11374: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_util_ng-zorro-antd_core_util"), __webpack_require__.e("default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-core-time_mjs")]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/time */ 17221))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/time",
	},
	70786: {
		fallback: () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_keycodes_mjs").then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 74879))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/keycodes",
	},
	9832: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_a11y_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 72102))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/a11y",
	},
	47768: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/form */ 10228))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/form",
	},
	30580: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_polyfill_ng-zorro-antd_core_polyfill"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_environments_ng-zorro-antd_core_en-53451e"), __webpack_require__.e("default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-core-services_mjs")]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/services */ 59062))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/services",
	},
	46026: {
		fallback: () => (__webpack_require__.e("default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-core-overlay_mjs").then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/overlay */ 71318))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/overlay",
	},
	7932: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/pipes */ 72411))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/pipes",
	},
	38170: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_polyfill_ng-zorro-antd_core_polyfill"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_coercion_angular_cdk_coercion"), __webpack_require__.e("default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-core-animation_mjs")]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/animation */ 94796))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/animation",
	},
	67520: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_i18n_ng-zorro-antd_i18n"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_portal_angular_cdk_portal"), __webpack_require__.e("default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-empty_mjs")]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/empty */ 42643))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/empty",
	},
	4348: {
		fallback: () => (__webpack_require__.e("default-node_modules_angular_cdk_fesm2022_scrolling_mjs").then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 79975))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/scrolling",
	},
	74432: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_config_ng-zorro-antd_core_config"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_outlet_ng-zorro-antd_core_outlet"), __webpack_require__.e("default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-progress_mjs")]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/progress */ 48393))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/progress",
	},
	13760: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_config_ng-zorro-antd_core_config"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_outlet_ng-zorro-antd_core_outlet"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_overlay_angular_cdk_overlay"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_overlay_ng-zorro-antd_core_overlay"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-zorro-antd_core_color_ng-zorro-antd_core_color"), __webpack_require__.e("default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-tooltip_mjs")]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/tooltip */ 28573))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/tooltip",
	},
	69648: {
		fallback: () => (__webpack_require__.e("webpack_container_remote_institution_Routes").then(() => (() => (__webpack_require__(/*! institution/Routes */ 59096))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "institution/Routes",
	},
	44128: {
		fallback: () => (__webpack_require__.e("webpack_container_remote_authentication_Routes").then(() => (() => (__webpack_require__(/*! authentication/Routes */ 42272))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "authentication/Routes",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		759
	],
	"default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser": [
		52950
	],
	"default-webpack_sharing_consume_default_ngrx_store_ngrx_store": [
		92668
	],
	"default-webpack_sharing_consume_default_angular_platform-browser_animations_angular_platform--77fea9": [
		59089,
		32994,
		9649,
		30171
	],
	"apps_shell_src_bootstrap_ts": [
		68324,
		53962,
		56202,
		67674,
		86447
	],
	"default-webpack_sharing_consume_default_rxjs_rxjs": [
		61528
	],
	"default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators": [
		48196
	],
	"default-webpack_sharing_consume_default_angular_common_angular_common": [
		40845
	],
	"default-webpack_sharing_consume_default_angular_core_primitives_signals_angular_core_primitiv-a0f1dc": [
		89193
	],
	"default-node_modules_angular_core_fesm2022__resource-chunk_mjs": [
		52409
	],
	"default-webpack_sharing_consume_default_angular_animations_browser_angular_animations_browser": [
		45211
	],
	"default-webpack_sharing_consume_default_angular_common_http_angular_common_http": [
		59715
	],
	"default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop": [
		19315
	],
	"default-webpack_sharing_consume_default_ng-zorro-antd_core_config_ng-zorro-antd_core_config": [
		25048
	],
	"default-webpack_sharing_consume_default_ng-zorro-antd_icon_ng-zorro-antd_icon": [
		78216
	],
	"default-webpack_sharing_consume_default_ng-zorro-antd_core_transition-patch_ng-zorro-antd_cor-88efb7": [
		92156
	],
	"default-webpack_sharing_consume_default_angular_forms_angular_forms": [
		33611
	],
	"default-webpack_sharing_consume_default_ng-zorro-antd_button_ng-zorro-antd_button": [
		13824
	],
	"default-webpack_sharing_consume_default_lucide-angular_lucide-angular": [
		55159
	],
	"default-webpack_sharing_consume_default_aws-amplify_auth_aws-amplify_auth": [
		9266
	],
	"default-webpack_sharing_consume_default_angular_cdk_drag-drop_angular_cdk_drag-drop": [
		72548
	],
	"default-libs_shared-ui_src_index_ts": [
		79732,
		96288,
		46700,
		57474,
		96210,
		56352,
		23316
	],
	"default-webpack_sharing_consume_default_ng-zorro-antd_core_util_ng-zorro-antd_core_util": [
		13192
	],
	"default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi": [
		3132
	],
	"default-webpack_sharing_consume_default_ng-zorro-antd_space_ng-zorro-antd_space": [
		43294
	],
	"default-webpack_sharing_consume_default_ng-zorro-antd_core_wave_ng-zorro-antd_core_wave": [
		67870
	],
	"default-webpack_sharing_consume_default_ng-zorro-antd_core_polyfill_ng-zorro-antd_core_polyfill": [
		37394
	],
	"default-webpack_sharing_consume_default_angular_cdk_coercion_angular_cdk_coercion": [
		21048
	],
	"default-webpack_sharing_consume_default_ng-zorro-antd_core_logger_ng-zorro-antd_core_logger": [
		74236
	],
	"default-webpack_sharing_consume_default_ng-zorro-antd_core_color_ng-zorro-antd_core_color": [
		32174
	],
	"default-webpack_sharing_consume_default_ng-zorro-antd_core_environments_ng-zorro-antd_core_en-53451e": [
		80388
	],
	"default-webpack_sharing_consume_default_angular_cdk_overlay_angular_cdk_overlay": [
		53048
	],
	"default-webpack_sharing_consume_default_angular_cdk_platform_angular_cdk_platform": [
		52538
	],
	"default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-core-services_mjs": [
		73916
	],
	"default-webpack_sharing_consume_default_ng-zorro-antd_core_outlet_ng-zorro-antd_core_outlet": [
		22294
	],
	"default-webpack_sharing_consume_default_ng-zorro-antd_i18n_ng-zorro-antd_i18n": [
		83672
	],
	"default-webpack_sharing_consume_default_angular_cdk_portal_angular_cdk_portal": [
		73856
	],
	"default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-i18n_mjs": [
		11374
	],
	"default-webpack_sharing_consume_default_angular_cdk_keycodes_angular_cdk_keycodes": [
		70786
	],
	"default-webpack_sharing_consume_default_angular_cdk_a11y_angular_cdk_a11y": [
		9832
	],
	"default-webpack_sharing_consume_default_ng-zorro-antd_core_form_ng-zorro-antd_core_form": [
		47768
	],
	"default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-input_mjs": [
		30580
	],
	"default-webpack_sharing_consume_default_ng-zorro-antd_core_overlay_ng-zorro-antd_core_overlay": [
		46026
	],
	"default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-modal_mjs": [
		7932
	],
	"default-webpack_sharing_consume_default_ng-zorro-antd_core_animation_ng-zorro-antd_core_animation": [
		38170
	],
	"default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-select_mjs": [
		67520,
		4348
	],
	"default-node_modules_ng-zorro-antd_fesm2022_ng-zorro-antd-upload_mjs": [
		74432,
		13760
	],
	"webpack_sharing_consume_default_institution_Routes_institution_Routes": [
		69648
	],
	"webpack_sharing_consume_default_authentication_Routes_authentication_Routes": [
		44128
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}